import Vue from 'vue';

var common = {};

/*
*   获取cookie
*   @params name  cookie名
* */
common.getCookie = function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
};

/*
*   设置cookie
*   @params c_name  cookie名
*   @params value   cookie值
*   @expiredays     cookie保存时长
* */
common.setCookie = function(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    //console.log(123);
    //console.log("document.domain==", document.domain);
    var href = window.location.host;
    if(href.indexOf("pinganwj.com") > 0 || href.indexOf("pawjzs.com") > 0){
        document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";domain=."+ document.domain +";path=/;expires=" + exdate.toGMTString());
    }else{
        document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
    }
};

/*
*   获取cookie
*   @params name  cookie名
* */
common.delCookie = function(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = common.getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/*
*   统计功能
* */
common.buttonCollect = function (buttonName) {
    var url = "https://image.pinganwj.com/analytics/analytics.js?v=1&type=2&content="+ buttonName + "&date=" + new Date().getTime() + parseInt(Math.random() * 1000000);
    var analytics = document.createElement('script');
    analytics.type = 'text/javascript';
    analytics.async = true;
    analytics.src = url;
    var _script = document.getElementsByTagName('script')[0];
    _script.parentNode.insertBefore(analytics, _script);
};

/*
*  调取casiframe
* */
common.addCasIframe = function (callback) {
    /*Vue.http.get(window.commonRoot + "/sso/getTicket").
    then(function (res) {
        callback();
    }).catch(function () {
        callback();
    });*/

    var isIE = /msie/i.test(navigator.userAgent) && !window.opera;
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src =  "/sso/getTicket";
    if (isIE) {
        iframe.onreadystatechange = function(){
            if(iframe.readyState == "loaded" || iframe.readyState == "complete"){
                callback();
            }
        };
    } else {
        iframe.onload = function(){
            callback();
        };
    }
    document.body.appendChild(iframe);
};

common.isIE = function(){
    var userAgent = navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    return ( isIE || isEdge || isIE11 );
};


export default common;



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 1